import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';

const routes: Routes = [
  {
      path: '',
      children: [
          {
              path: '',
              redirectTo: 'login',
              pathMatch: 'full'
          },
          {
              path: 'login',
              component: SignInComponent
          },
          {
            path: 'sign-up',
            component: SignUpComponent
        }
      ]
  },
  {
      path: 'forgot-password', component: ForgotPasswordComponent
  },
  {
    path: 'thank-you', component: ThankYouComponent
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {
  
 }
